module.exports = __webpack_public_path__ + "img/img35.30beb79a.png";